export enum FileResponseType {
  SVG = 'text',
  BLOB = 'blob',
}
